
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useNavigate } from "react-router-dom";

type ContentType = {
  id: string;
  name: string;
  description: string;
};

const contentTypes: ContentType[] = [
  {
    id: "intellectual-property",
    name: "Intellectual Property Violation",
    description: "Content that infringes on copyrights, patents, or other intellectual property rights"
  },
  {
    id: "misinformation",
    name: "Factual Inaccuracy",
    description: "Content containing demonstrably false or misleading information"
  },
  {
    id: "security-risk",
    name: "Security Risk",
    description: "Content that poses security vulnerabilities or discloses sensitive information"
  },
  {
    id: "ethical-concerns",
    name: "Ethical Concerns",
    description: "Content that violates ethical standards or community guidelines"
  },
  {
    id: "outdated-information",
    name: "Outdated Information",
    description: "Obsolete content that no longer reflects current knowledge or practices"
  },
  {
    id: "duplicate-content",
    name: "Duplicate Content",
    description: "Redundant information that exists elsewhere in the knowledge base"
  },
  {
    id: "privacy-violation",
    name: "Privacy Violation",
    description: "Content that discloses personal or private information without consent"
  },
  {
    id: "regulatory-compliance",
    name: "Regulatory Non-compliance",
    description: "Content that violates industry regulations or legal requirements"
  }
];

const CallForDestructionFunctionalArea = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<string | null>(null);

  const handleContinue = () => {
    if (selectedType) {
      const selectedTypeName = contentTypes.find(type => type.id === selectedType)?.name || selectedType;
      navigate("/call-for-destruction/bounty", { 
        state: { selectedArea: selectedTypeName } 
      });
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/engage")}
        />
      </div>

      <Card className="w-full max-w-3xl border border-gray-200">
        <CardContent className="p-6">
          <h2 className="text-2xl font-semibold text-center mb-6">Identify Content Issue Type</h2>
          
          <RadioGroup 
            value={selectedType || ""} 
            onValueChange={setSelectedType}
            className="space-y-4"
          >
            {contentTypes.map((type) => (
              <div 
                key={type.id} 
                className="flex items-start space-x-2 p-2 rounded-md hover:bg-gray-50"
              >
                <RadioGroupItem value={type.id} id={type.id} className="mt-1" />
                <div className="flex-1">
                  <Label 
                    htmlFor={type.id} 
                    className="font-medium cursor-pointer flex items-center"
                  >
                    {type.name} <span className="text-gray-500 ml-2">–</span>
                  </Label>
                  <p className="text-gray-600 text-sm ml-2">{type.description}</p>
                </div>
              </div>
            ))}
          </RadioGroup>
          
          <div className="flex justify-between mt-8">
            <Button 
              variant="outline" 
              onClick={() => navigate("/call-for-destruction")}
              className="border-gray-300"
            >
              Back
            </Button>
            <Button 
              onClick={handleContinue}
              disabled={!selectedType}
              className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded"
            >
              Continue
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CallForDestructionFunctionalArea;
